import { UploadOutlined } from "@ant-design/icons";
import { Avatar, Button, Col, Divider, Form, Row, Upload } from "antd";
import TextArea from "antd/es/input/TextArea";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import { db } from "../../../../../../../firebase";

const SupportStaffInspection = ({ itemId, listId, checkedItems }) => {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");

  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
  
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="list-container">
      <div className="item-page">
        <Form className="item-page-container" layout="vertical">
          <Row gutter={[0, 24]}>
            <Col span={24}>
              <h3 className="main-heading">
                If you need Gina to do an inspection check off this task to
                create automatically.
              </h3>
            </Col>
            <Col span={24}>
              <Row justify="end" gutter={[8, 0]}>
                <Col>
                  <Button>Skip</Button>
                </Col>
                <Col>
                  <Button
                    type="primary"
                    onClick={handleComplete}
                    disabled={isDisabled}
                  >
                    Completed
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider />

          <Row>
            <Col span={2}>
              <Avatar>KA</Avatar>
            </Col>
            <Col span={22}>
              <TextArea
                style={{
                  height: 200,
                  resize: "none",
                }}
                placeholder="Write a comment… Type @ to mention other users."
              />
            </Col>
          </Row>
          <Row justify="end" gutter={16}>
            <Col>
              <Upload>
                <Button style={{ marginTop: "10px" }}>
                  <UploadOutlined />
                </Button>
              </Upload>
            </Col>
            <Col>
              <Button style={{ marginTop: "10px" }}>Send</Button>
            </Col>{" "}
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default SupportStaffInspection;
